export default __webpack_public_path__ + "static/media/byd-logo.a2676ec3.png";